import { getMarketOverviewMetaTags } from './getMarketOverviewMetaTags';
import { getPossibleIndustryMetaTags } from './getPossibleIndustryMetaTags';
import { getPossibleSectorMetaTags } from './getPossibleSectorMetaTags';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

export const getMetaTagsByFilters = ({
  isConsumerOverview,
  profileType,
  industry,
  sector,
  pathname,
 }: IgetMetaTagsByFilters & { pathname: string }): IMetaTags => {
  let currentMetaTags = {
    title: 'Market Overview',
    description: '',
  };

  currentMetaTags = getMarketOverviewMetaTags({ isConsumerOverview, pathname });

  currentMetaTags = getPossibleIndustryMetaTags({ profileType, industry }) || currentMetaTags;

  currentMetaTags = getPossibleSectorMetaTags({ profileType, sector }) || currentMetaTags;

  return currentMetaTags;
};
